module.exports = __webpack_public_path__ + "5fb1175989120e943a4dbd5de160910f.gif";


/*****************
 ** WEBPACK FOOTER
 ** ./components/Message/images/siebren.gif
 ** module id = 393
 ** module chunks = 0
 **/